module.exports = __webpack_public_path__ + "resources/img/img_datahunt6_m.24c52fe81c05052556f7ef7362d8626c.png";